/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ProductionInfoCreate,
    ProductionInfoCreateFromJSON,
    ProductionInfoCreateFromJSONTyped,
    ProductionInfoCreateToJSON,
    ProductionSetObjectType,
    ProductionSetObjectTypeFromJSON,
    ProductionSetObjectTypeFromJSONTyped,
    ProductionSetObjectTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProductionSetCreate
 */
export interface ProductionSetCreate {
    /**
     * 
     * @type {string}
     * @memberof ProductionSetCreate
     */
    caseId: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionSetCreate
     */
    documentId: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionSetCreate
     */
    batesNumberPrefix: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionSetCreate
     */
    batesNumberStart: string;
    /**
     * 
     * @type {ProductionSetObjectType}
     * @memberof ProductionSetCreate
     */
    objectType?: ProductionSetObjectType;
    /**
     * 
     * @type {ProductionInfoCreate}
     * @memberof ProductionSetCreate
     */
    productionInfo?: ProductionInfoCreate;
}

export function ProductionSetCreateFromJSON(json: any): ProductionSetCreate {
    return ProductionSetCreateFromJSONTyped(json, false);
}

export function ProductionSetCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductionSetCreate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'caseId': json['caseId'],
        'documentId': json['documentId'],
        'batesNumberPrefix': json['batesNumberPrefix'],
        'batesNumberStart': json['batesNumberStart'],
        'objectType': !exists(json, 'objectType') ? undefined : ProductionSetObjectTypeFromJSON(json['objectType']),
        'productionInfo': !exists(json, 'productionInfo') ? undefined : ProductionInfoCreateFromJSON(json['productionInfo']),
    };
}

export function ProductionSetCreateToJSON(value?: ProductionSetCreate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'caseId': value.caseId,
        'documentId': value.documentId,
        'batesNumberPrefix': value.batesNumberPrefix,
        'batesNumberStart': value.batesNumberStart,
        'objectType': ProductionSetObjectTypeToJSON(value.objectType),
        'productionInfo': ProductionInfoCreateToJSON(value.productionInfo),
    };
}


